import { css } from 'styled-components';

export const LegalSectionSkipLP = css`
  text-align: center;
  margin-bottom: 30px;
  padding: 0 20px;
  max-width: 600px;

  @media only screen and ${({ theme }) => theme.device.laptopS} {
    margin-top: 12px;
  }
`;
